import {Fragment, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {BreadCrumb} from "../../component/Breadcrumb";
import {get, post} from "../../js/api";
import {markDirty, showMessage} from "../../js/main";
import {OrderInformation} from "../../component/OrderInformation";
import {Button} from "../../component/form/Button";
import {germanDate, RefreshSignal, useChangeEffect} from "../../js/util";
import {OrderCorrespondence} from "../../component/OrderCorrespondence";

const refresh = new RefreshSignal();

export const mapState = paymentState => {
    if (paymentState == "AWAIT_USER") {
        return "Bezahlung offen";
    } else if (paymentState == "PENDING") {
        return "Bestätigung durch Stripe ausständig";
    } else if (paymentState == "SUCCESS") {
        return "Bezahlt";
    } else if (paymentState == "FAILED") {
        return "Fehlgeschlagen";
    } else if (paymentState == "CANCELED"){
        return "Storniert";
    }
    return "Unbekannt";
}
export const UpdateOrder = ({orders}) => {

    const {orderId} = useParams();

    const [editmode, setEditmode] = useState(false);
    const [reply, setReply] = useState();

    const [selectedOrder, setSelectedOrder] = useState();
    const [paymentInfo, setPaymentInfo] = useState();
    const [referencingOrderInfo, setReferencingOrderInfo] = useState();
    const [isSubmitting, setSubmitting] = useState(false);

    const formRef = useRef();


    useEffect(() => {
        if (orders) {
            setSelectedOrder(orders.find(o => o.id === parseInt(orderId)));
        }
        get("/orders/" + orderId + "?detailed=true").then(detailed =>{
            //orderInfo stays the same, prevents more changes to the selectedOrder
            //setSelectedOrder(detailed.orderInfo);
            setPaymentInfo(detailed.paymentInfo);
            setReferencingOrderInfo(detailed.referencingOrderInfo);
        });
    }, [orders, orderId]); // eslint-disable-line react-hooks/exhaustive-deps

    useChangeEffect(() => {
        setEditmode(false);
        refresh.changed();
    }, [orders])

    const history = useHistory();

    const acceptOrder = () => {
        setSubmitting(true);
        post("/orders/" + orderId + "/acceptOrder").then(() => {
            markDirty();
            showMessage("Die Bestellung wurde als \"in Bearbeitung\" markiert.");
        }).finally(() => {
            setSubmitting(false);
        });
    }

    const completeOrder = () => {
        setSubmitting(true);
        post("/orders/" + orderId + "/completeOrder").then(() => {
            markDirty();
            showMessage("Die Bestellung wurde erfolgreich abgeschlossen.");
        }).finally(() => {
            setSubmitting(false);
        });
    };

    const updateOrder = () => {
        setSubmitting(true);
        const body = {order: selectedOrder, message: reply};
        post(`/orders/${orderId}/updateOrder`, body).then(() => {
            markDirty();
            showMessage("Die Bestellung wurde erfolgreich bearbeitet");

        }).finally(() => {
            setSubmitting(false);
        })
    }

    const cancelOrder = () => {
        if (!window.confirm("Wirklich stornieren?")) {
            return;
        }
        setSubmitting(true);
        post("/orders/" + orderId + "/cancelOrder").then(() => {
            markDirty();
            showMessage("Die Bestellung wurde erfolgreich storniert.");
        }).finally(() => {
            setSubmitting(false);
        });
    };

    const sendMessage = () => {
        if(!formRef.current.checkValidity()){
            return;
        }

        post(`/orders/${orderId}/correspondence`, reply).then((response) => {
            showMessage("Die Nachricht wurde gesendet.")
            refresh.changed();
        })
    }

    const cancelable_states = ["CREATED", "OPEN", "IN_PROGRESS", "AWAIT_PAYMENT"];

    const bearbeitungSpeichernButton = <Button key="save" theme="green mr-1 mb-1" width={230} submitting={isSubmitting}
                                               onClick={() => formRef.current.checkValidity() ? updateOrder() : null}>Bearbeitung speichern</Button>;

    const getButtons = ({state}) => {
        const content = [];

        if(editmode) {
            switch (state){
                case "IN_PROGRESS":
                    content.push(<Button key="trash" theme="red mr-1 mb-1" width={230} submitting={isSubmitting}
                                         onClick={() => window.location.reload()} type="button">Bearbeitung verwerfen</Button>);
                    content.push(bearbeitungSpeichernButton);
                    break;
            }
        }else{
            if (state === "IN_PROGRESS") {
                content.push(<Button key="complete" theme="green mr-1 mb-1" width={230} submitting={isSubmitting}
                                     onClick={completeOrder} type="button">Bestellung abschließen</Button>);
                content.push(<Button key="alter" theme="green mr-1 mb-1" width={230} submitting={isSubmitting}
                                     onClick={() => setEditmode(true)} type="button">Bestellung bearbeiten</Button>);
            } else if (state === "OPEN" || state === "AWAIT_USER") {
                content.push(<Button key="accept" theme="green mr-1 mb-1" width={230} submitting={isSubmitting}
                                     onClick={acceptOrder} type="button">Bestellung annehmen</Button>)
            } else if (state === "AWAIT_PAYMENT") {
                content.push(<Button key="accept2" theme="green mr-1 mb-1" width={230} submitting={isSubmitting}
                                     onClick={() => {
                                         if(window.confirm("Übernehmen dieser Bestellung führt zu einem Abbruch der Kundenbezahlung per Bezahllink. Trotzdem übernehmen?")){
                                             acceptOrder();
                                         }
                                     }} type="button">Bestellung annehmen</Button>)
            }
            if (cancelable_states.includes(state)) {
                content.push(<Button key="cancel" theme="red mr-1 mb-1" width={230} submitting={isSubmitting}
                                     onClick={cancelOrder}>Bestellung stornieren</Button>);
            }

        }


        return content;
    }

    return (
        <Fragment>
            {selectedOrder && <div>
                <BreadCrumb currentTitle={"Bestellung " + orderId} parentTitle="Bestellungen"
                            parentLink="/bestellungen"/>

                <form ref={formRef} onSubmit={(e) => e.preventDefault()}>
                    {getButtons(selectedOrder)}

                    <OrderInformation order={selectedOrder} referencingOrderInfo={referencingOrderInfo} showUser
                                      canJumpToUser updateOrderFunction={editmode ? setSelectedOrder : null}/>
                    {paymentInfo && <>
                        <h2 className="mt-1d5 mb-03">Bezahlinformationen</h2>

                        <table>
                            <tr>
                                <td width="200">Bezahlung durch</td>
                                <td>{paymentInfo.payer}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td>{mapState(paymentInfo.paymentState)}</td>
                            </tr>
                            {paymentInfo.intentId &&
                                <tr>
                                    <td>Stripe Intent-ID</td>
                                    <td>{paymentInfo.intentId}</td>
                                </tr>}
                            {paymentInfo.intentResponseDate && <tr>
                                <td>Stripe Bestätigungszeitpunkt</td>
                                <td>{germanDate(paymentInfo.intentResponseDate)}</td>
                            </tr>}
                        </table>
                    </>}

                    <OrderCorrespondence identifier={selectedOrder.id} onCreateReply={setReply}
                                         adminView={true} refresh={refresh}/>
                    <div className={"safe-actions mt-1"}>
                        {editmode && bearbeitungSpeichernButton}
                        {!editmode && reply?.type &&
                            <Button key="sendmsg" theme="blue mr-1 mb-1" width={230} submitting={isSubmitting}
                                    onClick={() => formRef.current.checkValidity() ? sendMessage() : null} type="button">Nachricht senden</Button>
                        }
                    </div>
                </form>
            </div>}
        </Fragment>
    );

}